import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NoteState, noteFeatureKey } from '../reducers/note.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as noteState from '../reducers/note.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, NoteState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Note SUB STATE
export const getNoteState = createSelector(getMainEmployeeState, state => state[noteFeatureKey]);
//#endregion

//#region NOTE SELECTORS
export const getNoteRequest = createSelector(getNoteState, noteState.getNoteRequest);
export const getNoteSuccess = createSelector(getNoteState, noteState.getNoteSuccess);
export const getNoteFailure = createSelector(getNoteState, noteState.getNoteFailure);
//#endregion

//#region NOTE DOCS SELECTORS
export const getNoteDocsRequest = createSelector(getNoteState, noteState.getNoteDocsRequest);
export const getNoteDocsSuccess = createSelector(getNoteState, noteState.getNoteDocsSuccess);
export const getNoteDocsFailure = createSelector(getNoteState, noteState.getNoteDocsFailure);
//#endregion
